<script setup lang="ts">
import { YEAR_PATTERN } from '#shared/constants'

defineProps<{
  disabled: boolean
}>()

const emit = defineEmits<{ update: [] }>()
const startYear = defineModel<string>('startYear', { default: '' })
const endYear = defineModel<string>('endYear', { default: '' })

const startYearError = ref<string | boolean>(false)
const endYearError = ref<string | boolean>(false)

function yearError(value: string): string | boolean {
  if (!value) {
    return false
  }
  return !YEAR_PATTERN.test(value) ? 'Ugyldig årstall' : false
}

watch(startYear, val => startYearError.value = yearError(val))
watch(endYear, val => endYearError.value = yearError(val))

const hasErrors = computed(() => !!startYearError.value || !!endYearError.value)

function handleUpdate() {
  if (!hasErrors.value) {
    emit('update')
  }
}
</script>

<template>
  <div class="w-full flex flex-col gap-s pb-s">
    <span class="text-small font-bold">
      Periode
    </span>
    <form class="input-field-container" @submit.prevent="handleUpdate" @change="handleUpdate">
      <FormInput
        id="startYear"
        v-model="startYear"
        v-model:error="startYearError"
        label="Fra (åååå)"
        placeholder=""
        :disabled="disabled"
        inputmode="numeric"
      />
      <FormInput
        id="endYear"
        v-model="endYear"
        v-model:error="endYearError"
        label="Til (åååå)"
        placeholder=""
        :disabled="disabled"
        inputmode="numeric"
      />
    </form>
  </div>
</template>

<style lang="postcss" scoped>
form.input-field-container {
  @apply flex gap-xs w-full;

  span {
    @apply text-base;
  }

  label {
    @apply w-[166px];
  }
}
</style>
